import { Flex, Text, Image, Input } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import VerificationInput from "./VerificationInput";
import ErrorIcon from "./assets/error.png";

const SentButton = ({ disabled }: { disabled?: boolean }) => {
  return (
    <Flex
      sx={{
        width: "95px",
        height: "30px",
        background: disabled ? "#DEDEDE" : "#D8762B",
        borderRadius: "20px",
        justifyContent: "center",
        alignItems: "center",
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <Text
        sx={{
          color: disabled ? "#848484" : "#fff",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        Sent
      </Text>
    </Flex>
  );
};

const CountdownButton = ({ seconds }: { seconds: number }) => {
  return (
    <Flex
      sx={{
        width: "95px",
        height: "30px",
        background: "#DEDEDE",
        borderRadius: "20px",
        justifyContent: "center",
        alignItems: "center",
        opacity: 0.6,
      }}
    >
      <Text
        sx={{
          color: "#848484",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {seconds}s
      </Text>
    </Flex>
  );
};

const ResendButton = () => {
  return (
    <Flex
      sx={{
        width: "95px",
        height: "30px",
        background: "#fff",
        borderRadius: "20px",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        border: "1px solid #D8762B",
      }}
    >
      <Text
        sx={{
          color: "#D8762B",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        Resent
      </Text>
    </Flex>
  );
};

const Email = ({
  onSend,
  onVerify,
  email,
  onEmail,
}: {
  onSend: () => void;
  onVerify: (code: string) => Promise<boolean>;
  email: string;
  onEmail: (email: string) => void;
}) => {
  const [code, setCode] = useState<string>("");
  const [buttonState, setButtonState] = useState<
    "sent" | "countdown" | "resend"
  >("sent");
  const [countdown, setCountdown] = useState(60);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationError, setVerificationError] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (buttonState === "countdown" && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            setButtonState("resend");
            return 60;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [buttonState, countdown]);

  const handleSendClick = () => {
    onSend();
    setButtonState("countdown");
    setCountdown(60);
  };

  const handleVerification = async (code: string) => {
    const success = await onVerify(code);
    console.log(success, "success");
    if (!success) {
      setVerificationError(true);
    }
  };

  const renderButton = () => {
    switch (buttonState) {
      case "sent":
        return (
          <div onClick={email ? handleSendClick : undefined}>
            <SentButton disabled={!email} />
          </div>
        );
      case "countdown":
        return <CountdownButton seconds={countdown} />;
      case "resend":
        return (
          <div onClick={handleSendClick}>
            <ResendButton />
          </div>
        );
    }
  };

  return (
    <Flex sx={{ width: "100%", flexDirection: "column" }}>
      <Text
        sx={{
          marginTop: "15px",
          color: "#333",
          fontSize: "20px",
          fontWeight: 700,
        }}
      >
        Email Address
      </Text>
      <Flex justify={"space-between"}>
        <Input
          variant="unstyled"
          sx={{
            flex: 1,
            marginTop: "10px",
            _placeholder: {
              color: "#DEDEDE",
              fontSize: "14px",
            },
          }}
          placeholder="My Email"
          value={email}
          onChange={(e) => {
            onEmail(e.target.value);
          }}
        ></Input>
        {renderButton()}
      </Flex>

      <Flex sx={{ position: "relative", marginTop: "20px" }} align={"center"}>
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 700,
          }}
        >
          Email verification code
        </Text>
        {verificationError && (
          <Flex
            sx={{
              marginLeft: "10px",
            }}
            align={"center"}
          >
            <Image src={ErrorIcon} width="12px"></Image>
            <Text
              sx={{
                color: "#FF3B30",
                fontSize: "14px",
                marginLeft: "5px",
              }}
            >
              Code Error
            </Text>
          </Flex>
        )}
      </Flex>

      <Flex sx={{ marginTop: "15px" }}>
        <VerificationInput
          length={6}
          error={verificationError}
          onChange={(code) => {
            console.log(code, "code");

            setVerificationCode(code);
            if (verificationError) {
              setVerificationError(false);
            }
            if (code.length === 6) {
              handleVerification(code);
            }
          }}
        />
      </Flex>
    </Flex>
  );
};

export default Email;
